import { useRef, useState } from 'react';
import Popover from '../../../components/Popover/Popover';
import { IonIcon, IonItem, IonLabel } from '@ionic/react';
import { logOutOutline } from 'ionicons/icons';
import Message from '../../../components/Message/Message';
import ArrowIcon from '../../../components/ArrowIcon/ArrowIcon';
import { useUserState } from '../../../hooks/context/useUserState';

interface UserButtonProps {
  onPopoverOpen?: () => void;
  onLogout: () => Promise<void>;
}

const UserButton = ({ onPopoverOpen, onLogout }: UserButtonProps) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const ref = useRef<HTMLHeadingElement>(null);

  const {
    state: { username },
  } = useUserState();

  const handleModalOpen = () => {
    setIsPopoverOpen(false);
    onPopoverOpen?.();
  };

  return (
    <div ref={ref} slot="end" className="user-button">
      <Popover
        isOpen={isPopoverOpen}
        onClickOutside={() => setIsPopoverOpen(false)}
        className="user-popover"
        style={
          ref.current && ref.current.offsetWidth
            ? { width: `${ref.current.offsetWidth}px` }
            : undefined
        }
        content={
          <div>
            {/* TODO: Enable when SQL will support multiple languages */}
            {/* <LanguageSwitcherAccordion /> */}
            <IonItem button onClick={handleModalOpen} lines="none">
              <IonLabel>
                <Message id={'support'} />
              </IonLabel>
            </IonItem>
            <IonItem button onClick={onLogout} lines="none">
              <IonIcon aria-hidden="true" icon={logOutOutline} slot="start" />
              <IonLabel>
                <Message id={'logOut'} />
              </IonLabel>
            </IonItem>
          </div>
        }
      >
        <IonItem
          button={true}
          lines="none"
          onClick={() => setIsPopoverOpen(true)}
        >
          {username}
          <ArrowIcon direction="down" slot="end" />
        </IonItem>
      </Popover>
    </div>
  );
};

export default UserButton;
